import { useMutation, useQueryClient } from "@tanstack/react-query";
import apiV2 from "api-v2";
import type { DisclaimerReview } from "../types/panel.type";

export const useReviewDisclaimer = (rfxId: number, evalId: number) => {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (params: { memberId: number; payload: DisclaimerReview }) =>
			apiV2.put(
				`/rfx/${rfxId}/evaluation/${evalId}/panel-members/${params.memberId}/disclaimer/review`,
				params.payload
			),
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: ["panel-members"] });
		},
	});
};
